/**
 * When data is already loaded but the skeleton flag was never set
 * (e.g. admin logout on the same store page), reveal content without refetching.
 */
const ensureSkeletonHidden = (isDataReady, hideSkeleton, setHideSkeleton) => {
    if (isDataReady && !hideSkeleton) {
        setHideSkeleton(true);
    }
};

export default ensureSkeletonHidden;
